/** Onboarding : création du profil + première pesée. */

import { ProfileForm } from '@/components/ProfileForm';
import { todayKey } from '@/domain';
import { useCreateWeight, useUpsertProfile } from '@/hooks/queries';
import { useAuth } from '@/lib/auth';
import { useTheme } from '@/theme/ThemeContext';

export function OnboardingPage() {
  const upsert = useUpsertProfile();
  const createWeight = useCreateWeight();
  const { logout } = useAuth();
  useTheme(); // applique le thème dès l'onboarding

  return (
    <div className="center-screen">
      <div className="card" style={{ maxWidth: 640, width: '100%' }}>
        <div className="page-header">
          <div>
            <h2>Bienvenue 👋</h2>
            <p>Configurons ton profil pour calculer ton objectif calorique.</p>
          </div>
          <button type="button" className="ghost" onClick={logout}>
            Déconnexion
          </button>
        </div>
        <ProfileForm
          askCurrentWeight
          submitLabel="Créer mon profil"
          onSubmit={async (values, currentWeight) => {
            await upsert.mutateAsync({ values });
            if (currentWeight != null) {
              await createWeight.mutateAsync({
                date: todayKey(),
                weight_kg: currentWeight,
              });
            }
          }}
        />
      </div>
    </div>
  );
}
